import React from 'react';
import styled from 'styled-components';
import {ScreenSizes} from '../../../types/responsive';
import monei_pay_group_en_1 from 'images/monei_pay_group_en_1.png';
import monei_pay_group_en_2 from 'images/monei_pay_group_en_2.png';
import monei_pay_group_es_1 from 'images/monei_pay_group_es_1.png';
import monei_pay_group_es_2 from 'images/monei_pay_group_es_2.png';
import {LanguageEnum} from '../../../locales/types';
import {useI18next} from 'gatsby-plugin-react-i18next';

const Screenshots = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  overflow: visible;
  grid-gap: 0 85px;
  transform: rotate(23deg) translateX(100px) scale(1.2) translateY(20px);

  @media (max-width: ${ScreenSizes.lg}) {
    margin: 0;
    flex: 2.5;
    grid-gap: 0 85px;
    transform: rotate(23deg) translateX(20px) translateY(40px);
  }

  @media (max-width: ${ScreenSizes.md}) {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    flex: 2.1;
    grid-gap: 30px 120px;
    transform: translateX(-40px) translateY(10px) rotate(15deg);
  }
  @media (max-width: ${ScreenSizes.sm}) {
    display: none;
  }
`;

const Screenshot = styled.img`
  max-width: 300px;
  &:last-child {
    margin-left: 15%;
  }
  @media (max-width: ${ScreenSizes.md}) {
    &:last-child {
      margin-left: 45%;
    }
  }
`;

export const RotatedScreenshots: React.FC = () => {
  const {language} = useI18next();
  const isSpanish = [LanguageEnum.es, LanguageEnum.ca].includes(language as LanguageEnum);
  const monei_pay_group_1 = isSpanish ? monei_pay_group_es_1 : monei_pay_group_en_1;
  const monei_pay_group_2 = isSpanish ? monei_pay_group_es_2 : monei_pay_group_en_2;

  return (
    <Screenshots>
      <Screenshot src={monei_pay_group_1} />
      <Screenshot src={monei_pay_group_2} />
    </Screenshots>
  );
};
